import { useState } from 'react';
import { Badge, Box, Flex, Loader, Popover, Stack, Text, Title } from '@mantine/core';
import * as goggleStatuses from '../../constants/googleStatuses';
import { prettifiedLabel } from '../../constants/labelPrettifier';

const GoogleStatusVisualizer = ({ statuses, type }) => {
  const [opened, setOpened] = useState(false);

  if (type === 'google') {
    type = 'assetGroup';
  }

  const data = statuses[type];

  if (!data) {
    return <Loader size="xs" />;
  }

  const { status, primaryStatus, primaryStatusReasons, adStrength } = data;

  return (
    <Box style={{ display: 'inline-block' }}>
      <Popover position="bottom" withArrow shadow="md" width={400} opened={opened} onChange={setOpened}>
        <Popover.Target>
          <div
            className={`statusCircle ${goggleStatuses.getPrimaryStatusColor(primaryStatus)}`}
            style={{ cursor: 'pointer', display: 'inline-block' }}
            onMouseEnter={() => setOpened(true)}
            onMouseLeave={() => setOpened(false)}
          />
        </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="sm">
          <Title order={6}>Google Ad Status</Title>

          <Box>
            <Text size="sm" fw={600}>Status:</Text>
            <Badge color={goggleStatuses.getBadgeColor(status)} mt={4}>
              {(() => {
                const Icon = goggleStatuses.getStatusIcon(status);
                return <Icon size={14} style={{ marginRight: 'var(--mantine-spacing-sm)' }} />;
              })()}
              {prettifiedLabel(status.replaceAll('_', ' ').toLowerCase())}
            </Badge>
          </Box>

          {adStrength && (
            <Box>
              <Text size="sm" fw={600}>Ad Strength:</Text>
              <Badge color={goggleStatuses.getBadgeColor(adStrength)} mt={4}>
                {(() => {
                  const Icon = goggleStatuses.getAdStrengthIcon(adStrength);
                  return <Icon size={14} style={{ marginRight: 'var(--mantine-spacing-sm)' }} />;
                })()}
                {prettifiedLabel(adStrength.toLowerCase())}
              </Badge>
            </Box>
          )}

          <Box>
            <Text size="sm" fw={600}>Primary Status:</Text>
            <Badge color={goggleStatuses.getBadgeColor(primaryStatus)} mt={4}>
              {(() => {
                const Icon = goggleStatuses.getPrimaryStatusIcon(primaryStatus);
                return <Icon size={14} style={{ marginRight: 'var(--mantine-spacing-sm)' }} />;
              })()}
              {prettifiedLabel(primaryStatus.replaceAll('_', ' ').toLowerCase())}
            </Badge>
          </Box>

          {primaryStatusReasons && primaryStatusReasons.length > 0 && (
            <Box>
              <Text size="sm" fw={600} mb={4}>Primary Reasons:</Text>
              <Flex wrap="wrap" gap="xs">
                {primaryStatusReasons.map((reason, index) => (
                  <Badge key={index} color="cyan" size="sm">
                    {prettifiedLabel(reason.replaceAll('_', ' ').toLowerCase())}
                  </Badge>
                ))}
              </Flex>
            </Box>
          )}
        </Stack>
      </Popover.Dropdown>
      </Popover>
    </Box>
  );
};

export default GoogleStatusVisualizer;
